import { Spacer, Tickbox } from '@adserve/adserve-react-components';
import React from 'react';
import {
    showCreditNotesContainerStyle,
    showInvoicesContainerStyle,
    tickboxLabelStyle
} from './BillingStyles';

const BillingDisplayOptions = ({
    campaign,
    changeMade,
    staticData,
    showInvoices,
    showCreditNotes,
    toggleShowInvoices,
    toggleShowCreditNotes,
    readOnly
}) => {
    return (
        <div style={{ display: 'flex' }}>
            <div
                style={showInvoicesContainerStyle(readOnly)}
                onClick={toggleShowInvoices}
                id={`campaign-show-invoices-input`}
            >
                <Tickbox
                    height={18}
                    width={18}
                    value={showInvoices}
                    disabled={readOnly}
                    id={`campaign-show-invoices-tickbox-input`}
                />

                <Spacer height={0} width={8} />

                <div>
                    <span style={tickboxLabelStyle}>
                        {window.translate('Show Invoices')}
                    </span>
                </div>
            </div>

            <Spacer height={0} width={25} />

            <div
                style={showCreditNotesContainerStyle(readOnly)}
                onClick={toggleShowCreditNotes}
                id={`campaign-show-credit-notes-input`}
            >
                <Tickbox
                    height={18}
                    width={18}
                    value={showCreditNotes}
                    disabled={readOnly}
                    id={`campaign-show-credit-notes-tickbox-input`}
                />

                <Spacer height={0} width={8} />

                <div>
                    <span style={tickboxLabelStyle}>
                        {window.translate('Show Credit Notes')}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BillingDisplayOptions;
